module.exports = __webpack_public_path__ + "media/images/icon_list/award-2b7cf54f040991e0ce31e526a0024211.svg";